export default __webpack_public_path__ + "static/media/download-logo.fc77b6fa.svg";